export const fiFI = {
  app: {
    categories: {
      convectors: 'Konvektorit',
      decorative: 'Design',
      electric: 'Sähköiset',
      panels: 'Paneelit',
      towel: 'Pyyhekuivaimet',
    },
    categoryLabel: 'Kategoria',
    categoryPlaceholder: 'Valitse kategoria',
    errorCategories: 'Kategorioiden lataaminen epäonnistui.',
    errorPanels: 'Radiaattoreiden lataaminen epäonnistui',
    loadingCategories: 'Ladataan kategorioita...',
    loadingPanels: 'Ladataan radiaattoreita...',
    panelLabel: 'Radiaattorit',
    panelPlaceholder: 'Valitse radiaattori',
    titles: {
      convectors: 'Konvektorilaskuri',
      decorative: 'Designpatterilaskuri',
      electric: 'Sähköpatterilaskuri',
      panels: 'Paneeliradiaattorilaskuri',
      towel: 'Pyyhekuivainlaskuri',
    },
  },
  calc: {
    actionButton: 'Näytä lasketut tuotteet',
    boost: 'Tehostustila',
    calculateRequiredButton: 'Laske tarvittava teho',
    calculating: 'Lasketaan...',
    comfort: 'Mukavuustila',
    downloadLabel: 'Lataa tiedot ({count})',
    emptyResults: 'Ei tuloksia vielä.',
    errorMatch: 'Tulosten laskeminen epäonnistui.',
    errorTypes: 'Radiaattorityyppien lataaminen epäonnistui...',
    flowTemp: 'Menovesi C°',
    height: 'Korkeus',
    length: 'Pituus',
    loadingTypes: 'Ladataan tyyppejä...',
    modeLabel: 'Tila',
    modes: {
      cooling: 'Viilennys',
      heating: 'Lämmitys',
    },
    radiatorType: 'Radiaattorityyppi',
    requiredWatts: 'Tarvittava teho (W)',
    resultsMessage: '{count} tuotetta saatavilla valituilla asetuksilla.',
    returnTemp: 'Paluuvesi C°',
    roomTemp: 'Huonelämpötila C°',
    selectAllLabel: 'Valitse kaikki tuotteet',
    selectItemLabel: 'Valitse tuote ladattavaksi',
    selectPanel: 'Valitse radiaattori laskeaksesi',
    standby: 'Valmiustila',
    tableHeaders: {
      calculatedWattage: 'Teho',
      co2Equivalent: 'CO2-ekvivalentti per kg materiaalia',
      depth: 'Syvyys [mm]',
      description: 'Tuotekuvaus',
      dop: 'DoP',
      eudop: 'EU DoP',
      height: 'Korkeus [mm]',
      itemId: 'Tuotekoodi',
      length: 'Pituus [mm]',
      waterContent: 'Vesisisältö',
      weight: 'Paino',
    },
    title: 'Laskelmat',
    tolerance: 'Toleranssi',
    typeCooling: 'Viilennys',
    typeGroupLabel: 'Tyyppi',
    typeHeating: 'Lämmitys',
  },
  existingRadiator: {
    description:
      'HUOMIO! Tämä laskuri on vain suuntaa antava. Suunnittelupalvelumme auttaa laskemaan tarkat lämpöhäviöt. Kysy tarjous myyjältäsi.',
    height: 'Radiaattorin korkeus',
    length: 'Radiaattorin pituus',
    resultLabelTemplate: 'Lämpötehon tarve, laskettu {temp} järjestelmän lämpötilalla',
    select: 'Valitse',
    temperature: 'Järjestelmän lämpötila',
    type: 'Radiaattorityyppi',
  },
  matrixCalc: {
    axisHeight: 'Korkeus (mm)',
    axisLength: 'Pituus (mm)',
    axisType: 'Tyyppi',
    calculateButton: 'Calculate',
    displayLabel: 'Näyttö',
    exportExcel: 'Vie Excelinä',
    exportPdf: 'Vie PDF-tiedostona',
    print: 'Tulosta',
    hideOutOfRange: 'Piilota alueen ulkopuoliset tuotteet',
    showAll: 'Näytä kaikki',
    loading: 'Loading...',
    lockHeight: 'Korkeus',
    lockLabel: 'Lukitse mitta',
    lockLength: 'Pituus',
    lockType: 'Tyyppi',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Laske',
    clearButton: 'Tyhjennä',
    fields: {
      ceilingHeight: 'Huonekorkeus',
      doorInsulation: 'Ovieristys',
      floorInsulation: 'Lattiaeristys',
      glazingArea: 'Lasipinta-ala',
      glazingMode: 'Lasipinta-ala',
      glazingQuality: 'Lasin laatu',
      length: 'Pituus',
      outerWalls: 'Ulkoseinät',
      projectedDesignTemp: 'Mitoitusulkolämpötila',
      roofInsulation: 'Kattoeristys',
      roomArea: 'Huoneen pinta-ala',
      roomFloor: 'Kerros',
      roomInsulation: 'Huoneen eristys',
      roomPreset: 'Huonetyyppi',
      roomTemperature: 'Huonelämpötila',
      roomType: 'Huonetyyppi',
      uncertaintyFactor: 'Epävarmuuskerroin',
      ventilation: 'Ilmanvaihdon taso',
      wallInsulation: 'Seinäeristys',
      width: 'Leveys',
      windConditions: 'Tuuliolosuhteet',
      windowInsulation: 'Ikkunaeristys',
    },
    intro:
      'HUOMIO! Tämä laskuri on vain suuntaa antava. Suunnittelupalvelumme auttaa laskemaan tarkat lämpöhäviöt. Kysy tarjous myyjältäsi.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Yli 20%',
        low: 'Alle 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Yli 20%',
        below_10: 'Alle 10%',
        from_10_to_20: '10% - 20%',
        no_windows: 'Ei ikkunoita',
      },
      insulationValue: {
        good: 'Hyvä',
        medium: 'Keskitaso',
        poor: 'Heikko',
        very_good: 'Erittäin hyvä',
      },
      qualityValue: {
        modern_excellent: 'Mordernit, kiinteät',
        modern_good: 'Modernit, hyvä energiatehokkuus',
        old_poor: 'Vanhat, heikko energiatehokkuus',
        traditional_medium: 'Perinteiset, keskitason energiatehokkuus',
      },
      roomValue: {
        bathroom_24: 'Olohuone/Muu (21°C)',
        bedroom_20: 'Makuuhuone (20°C)',
        garage_12: 'Autotalli (12 C°)',
        livingroom_22: 'Makuuhuone (18°C)',
        storage_16: 'Varasto (16 C°)',
        extra_1: 'Olohuone/Muu (21°C)',
        extra_2: 'Kodinhoitohuone (22°C)',
        extra_3: 'Tekninen Tila (17°C)',
      },
      select: 'Valitse',
      storeyValue: {
        ground_multi: 'Pohjakerros (monikerroksinen)',
        ground_single: 'Pohjakerros (yksikerroksinen)',
        interim: 'Välikerros',
        top_multi: 'Ylin kerros (monikerroksinen)',
      },
      temp: {
        climate_zone_1: '-26°C (ilmastoalue I)',
        climate_zone_2: '-29ºC (ilmastoalue II)',
        climate_zone_3: '-32°C (ilmastoalue III)',
        climate_zone_4: '-38°C (ilmastoalue IV)',
      },
      windInfluence: {
        normal: 'Normaali',
        strong: 'Voimakas',
        weak: 'Heikko',
      },
    },
    roomPresets: {
      bathroom: 'Kylpyhuone',
      bedroom: 'Makuuhuone',
      garage: 'Autotalli',
      kitchen: 'Keittiö',
      living: 'Olohuone',
      storage: 'Varasto',
    },
    sections: {
      dimensions: 'Huoneen mitat',
      insulation: 'Eristys',
      placement: 'Sijainti',
      result: 'Tulos',
      temps: 'Lämpötilat',
      ventilation: 'Ilmanvaihto',
    },
    title: 'Huoneen lämpöhäviölaskuri',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Käytä',
  },
  slider: {
    from: 'Alkaen',
    to: 'Asti',
    value: 'Arvo',
  },
}
